import { configureStore } from "@reduxjs/toolkit";
import LoginSessionData from "./login/loginStore";
import ModalToShow from "./ModalToShow";
import verticalReducer from "@hooks/store/verticalSlice";

export const store = configureStore({
  reducer: {
    loginSessionData: LoginSessionData,
    modalToShow: ModalToShow,
    vertical: verticalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
